/**
 * Vista: Productos (ERP F1, B1 · diseño §2.2)
 * El producto es el artículo comercial (SKU); una presentación = un producto; sin kits.
 * Al elegir la línea se muestran los controles que exige (serie, motor, lote, caducidad, pedimento)
 * y se piden sus atributos descriptivos. Patrón de 2 pestañas: «Consultar» y «Agregar / editar».
 */

import catalogos from '../../services/erpCatalogos.service.js';
import lineaComercialService from '../../services/lineaComercial.service.js';
import api from '../../services/api.js';
import permisos from '../../services/permissions.service.js';
import modal from '../../utils/modal.js';
import toast from '../../utils/toast.js';
import { esc, errMsg, estadoBadge, chipsControles, val, numOrNull, NOMBRE_CONTROL } from './erpUi.js';
import { permisosPantalla, pestanasHtml, Pestanas } from '../../utils/pestanasErp.js';

export default {
  data: {
    productos: [], lineas: [], marcas: [], fabricantes: [], modelos: [], unidades: [],
    lineaActual: null, editing: null,
    filters: { search: '', linea: '', marca_id: '', bajas: false }
  },

  async render() {
    const pp = permisosPantalla('productos');
    const formulario = `
      <div class="card erp-form-card" id="prodFormCard">
        <div class="card-header">
          <h2 class="card-title" id="prodFormTitulo">Nuevo producto</h2>
          <span class="text-muted">Cada presentación (1 L, 5 L, 20 L) es un producto distinto.</span>
        </div>
        <form id="prodForm" autocomplete="off">
          <div class="form-row">
            <div class="form-group">
              <label>Línea *</label>
              <select id="pr_linea" class="form-control" required><option value="">— Elige la línea —</option></select>
            </div>
            <div class="form-group">
              <label>Clave *</label>
              <input type="text" id="pr_clave" class="form-control" maxlength="30" required placeholder="Patrón Aspel: AG-IND-VGE0601AR" style="text-transform:uppercase;" />
            </div>
            <div class="form-group" style="grid-column: span 2;">
              <label>Descripción *</label>
              <input type="text" id="pr_descripcion" class="form-control" maxlength="250" required placeholder="Ej: FOLIAR BIOAMIN 5 L" />
            </div>
          </div>
          <div id="pr_controles" class="erp-aviso erp-aviso-info" style="display:none;"></div>
          <div class="form-row">
            <div class="form-group">
              <label>Marca</label>
              <select id="pr_marca" class="form-control"><option value="">—</option></select>
            </div>
            <div class="form-group">
              <label>Fabricante</label>
              <select id="pr_fabricante" class="form-control"><option value="">— El de la marca —</option></select>
            </div>
            <div class="form-group" id="pr_modelo_grupo">
              <label>Modelo (maquinaria)</label>
              <select id="pr_modelo" class="form-control"><option value="">— No aplica —</option></select>
            </div>
          </div>
          <div class="form-row">
            <div class="form-group">
              <label>Tipo</label>
              <select id="pr_tipo" class="form-control"><option value="bien">Bien</option><option value="servicio">Servicio</option></select>
            </div>
            <div class="form-group">
              <label>Uso</label>
              <select id="pr_uso" class="form-control"><option value="venta">Se vende</option><option value="interno">Uso interno</option></select>
            </div>
            <div class="form-group">
              <label>Unidad de medida *</label>
              <select id="pr_um" class="form-control" required></select>
            </div>
            <div class="form-group">
              <label>Presentación</label>
              <input type="text" id="pr_presentacion" class="form-control" maxlength="40" placeholder="Ej: 5 L" />
            </div>
            <div class="form-group">
              <label>Contenido neto</label>
              <input type="number" id="pr_contenido" class="form-control" step="0.0001" min="0" placeholder="Ej: 5" />
            </div>
          </div>

          <div class="erp-seccion" id="pr_atributos_seccion" style="display:none;">
            <h4>Atributos de la línea</h4>
            <div class="form-row" id="pr_atributos"></div>
          </div>

          <div class="erp-seccion">
            <h4>Fiscal, garantía y costo</h4>
            <div class="form-row">
              <div class="form-group">
                <label>Clave SAT producto/servicio</label>
                <input type="text" id="pr_sat" class="form-control" maxlength="8" placeholder="8 dígitos (catálogo SAT)" />
              </div>
              <div class="form-group">
                <label>Garantía la otorga</label>
                <select id="pr_gar_otorga" class="form-control">
                  <option value="">—</option><option value="fabricante">Fabricante</option><option value="agromx">AgroMX</option>
                  <option value="distribuidor">Distribuidor</option><option value="sin_garantia">Sin garantía</option>
                </select>
              </div>
              <div class="form-group">
                <label>Garantía (meses)</label>
                <input type="number" id="pr_gar_meses" class="form-control" min="0" max="240" placeholder="La de la línea" />
              </div>
              <div class="form-group">
                <label>Garantía (horas)</label>
                <input type="number" id="pr_gar_horas" class="form-control" min="0" placeholder="Tractores: lo que ocurra primero" />
              </div>
            </div>
            <div class="form-row">
              <div class="form-group">
                <label>Costo estimado</label>
                <input type="number" id="pr_costo" class="form-control" min="0" step="0.01" placeholder="Producto nuevo sin historial" />
              </div>
              <div class="form-group">
                <label>Moneda del costo</label>
                <select id="pr_costo_moneda" class="form-control"><option value="">—</option><option>MXN</option><option>USD</option><option>EUR</option></select>
              </div>
              <div class="form-group" style="grid-column: span 2;">
                <label>Requisitos de entrega</label>
                <div class="erp-checks" style="padding-top:.4rem;">
                  <label class="erp-check"><input type="checkbox" id="pr_req_gps" /> GPS</label>
                  <label class="erp-check"><input type="checkbox" id="pr_req_capacitacion" /> Capacitación</label>
                  <label class="erp-check"><input type="checkbox" id="pr_req_cliente_final" /> Cliente final</label>
                  <label class="erp-check"><input type="checkbox" id="pr_req_responsiva" /> Responsiva</label>
                </div>
              </div>
            </div>
          </div>

          <div class="erp-acciones-form">
            <button type="button" class="btn btn-secondary" id="btnProdLimpiar">Cancelar</button>
            <button type="submit" class="btn btn-primary" id="btnProdGuardar">Guardar producto</button>
          </div>
        </form>
      </div>`;

    const consultar = `
      <div class="filters-card">
        <div class="filters-grid">
          <div class="form-group"><label>Buscar</label><input type="text" id="f_search" class="form-control" placeholder="Clave o descripción…" /></div>
          <div class="form-group"><label>Línea</label><select id="f_linea" class="form-control"><option value="">Todas</option></select></div>
          <div class="form-group"><label>Marca</label><select id="f_marca" class="form-control"><option value="">Todas</option></select></div>
          <div class="form-group" style="display:flex;align-items:flex-end;"><label class="erp-check"><input type="checkbox" id="f_bajas" /> Ver dados de baja</label></div>
        </div>
      </div>

      <div class="card">
        <div class="table-container">
          <table class="table">
            <thead><tr>
              <th>Clave</th><th>Descripción</th><th class="tbl-hide-mobile">Línea</th><th class="tbl-hide-mobile">Marca</th>
              <th class="tbl-hide-mobile">Exige</th><th class="tbl-hide-mobile">Unidad</th><th>Estado</th><th style="text-align:right;">Acciones</th>
            </tr></thead>
            <tbody id="prodBody"><tr><td colspan="8" class="text-center"><div class="loading-spinner"></div></td></tr></tbody>
          </table>
        </div>
        <div class="text-muted" id="prodTotal" style="font-size:.8rem;padding-top:.5rem;"></div>
      </div>
    `;
    return pestanasHtml({ id: 'prod', titulo: 'Productos', ...pp, consultar, formulario });
  },

  async afterRender() {
    if (!permisos.canView('productos')) {
      document.getElementById('content').innerHTML = '<div style="padding:2rem;text-align:center;"><h2>Acceso denegado</h2></div>';
      return;
    }
    window.currentView = this;
    this.data.editing = null;
    this.data.lineaActual = null;
    this.tabs = new Pestanas('prod', { alAgregar: () => this.limpiar() });
    await this.cargarCatalogos();
    this.setupListeners();
    await this.cargar();
  },

  async cargarCatalogos() {
    const [rl, rm, rf, rmo, ru] = await Promise.all([
      lineaComercialService.listar({ activo: 'true' }).catch(() => null),
      catalogos.marcas.listar({ activo: 'true' }).catch(() => null),
      catalogos.fabricantes.listar({ activo: 'true' }).catch(() => null),
      api.get('/modelos/activos').catch(() => null),
      catalogos.unidadesMedida.listar().catch(() => null)
    ]);
    this.data.lineas = rl?.data?.lineas || [];
    this.data.marcas = rm?.data?.marcas || [];
    this.data.fabricantes = rf?.data?.fabricantes || [];
    this.data.modelos = rmo?.data?.modelos || [];
    this.data.unidades = (ru?.data?.unidades || []).filter((u) => u.activo);
    const opt = (v, t) => `<option value="${esc(v)}">${esc(t)}</option>`;
    const llenar = (id, primera, items) => { const el = document.getElementById(id); if (el) el.innerHTML = primera + items.join(''); };
    llenar('pr_linea', '<option value="">— Elige la línea —</option>', this.data.lineas.map((l) => opt(l.codigo, `${l.codigo} · ${l.descripcion}`)));
    llenar('f_linea', '<option value="">Todas</option>', this.data.lineas.map((l) => opt(l.codigo, `${l.codigo} · ${l.descripcion}`)));
    llenar('pr_marca', '<option value="">—</option>', this.data.marcas.map((m) => opt(m.id, m.nombre)));
    llenar('f_marca', '<option value="">Todas</option>', this.data.marcas.map((m) => opt(m.id, m.nombre)));
    llenar('pr_fabricante', '<option value="">— El de la marca —</option>', this.data.fabricantes.map((f) => opt(f.id, f.nombre)));
    llenar('pr_modelo', '<option value="">— No aplica —</option>', this.data.modelos.map((m) => opt(m.id, `${m.codigo} · ${m.nombre}`)));
    llenar('pr_um', '', this.data.unidades.map((u) => opt(u.id, `${u.clave} · ${u.nombre} (SAT ${u.clave_sat})`)));
    const pza = this.data.unidades.find((u) => u.clave === 'PZA');
    if (pza && document.getElementById('pr_um')) document.getElementById('pr_um').value = pza.id;
  },

  setupListeners() {
    document.getElementById('prodForm')?.addEventListener('submit', (e) => { e.preventDefault(); this.guardar(); });
    document.getElementById('btnProdLimpiar')?.addEventListener('click', () => { this.limpiar(); this.tabs.volver(); });
    document.getElementById('pr_linea')?.addEventListener('change', (e) => this.alCambiarLinea(e.target.value));
    let t;
    document.getElementById('f_search')?.addEventListener('input', (e) => { clearTimeout(t); t = setTimeout(() => { this.data.filters.search = e.target.value; this.cargar(); }, 300); });
    document.getElementById('f_linea')?.addEventListener('change', (e) => { this.data.filters.linea = e.target.value; this.cargar(); });
    document.getElementById('f_marca')?.addEventListener('change', (e) => { this.data.filters.marca_id = e.target.value; this.cargar(); });
    document.getElementById('f_bajas')?.addEventListener('change', (e) => { this.data.filters.bajas = e.target.checked; this.cargar(); });
  },

  /** Muestra lo que exige la línea y arma los campos de sus atributos. */
  async alCambiarLinea(codigo, valores = []) {
    const aviso = document.getElementById('pr_controles');
    const sec = document.getElementById('pr_atributos_seccion');
    const cont = document.getElementById('pr_atributos');
    this.data.lineaActual = null;
    if (!codigo) { aviso.style.display = 'none'; sec.style.display = 'none'; cont.innerHTML = ''; return; }
    try {
      const res = await lineaComercialService.obtener(codigo);
      const l = res?.data;
      this.data.lineaActual = l;
      const ctl = (l.controles || []).filter((c) => c.aplica);
      const partes = ctl.map((c) => `${NOMBRE_CONTROL[c.control]}${c.obligatorio ? ' <strong>(obligatorio)</strong>' : ' (opcional)'}`);
      const extras = [];
      if (!l.vendible) extras.push('esta línea <strong>no se vende</strong>: el producto va como uso interno');
      if (!l.inventariable) extras.push('esta línea <strong>no lleva inventario</strong>: el producto va como servicio');
      if (l.garantia_meses_default != null) extras.push(`garantía por omisión: ${l.garantia_meses_default} meses`);
      aviso.innerHTML = `<strong>${esc(l.codigo)}</strong> · Al recibir y vender se pedirá: ${partes.length ? partes.join(', ') : 'ningún control'}.${extras.length ? '<br>' + extras.join(' · ') : ''}`;
      aviso.style.display = 'block';
      if (!this.data.editing) {
        if (!l.vendible) document.getElementById('pr_uso').value = 'interno';
        if (!l.inventariable) document.getElementById('pr_tipo').value = 'servicio';
      }
      const attrs = (l.atributos || []).filter((a) => a.nivel === 'producto');
      const porId = new Map(valores.map((v) => [Number(v.atributo_id), v.valor]));
      cont.innerHTML = attrs.map((a) => {
        const v = porId.has(Number(a.atributo_id)) ? porId.get(Number(a.atributo_id)) : '';
        const lab = `${esc(a.nombre)}${a.unidad ? ` (${esc(a.unidad)})` : ''}${a.obligatorio ? ' *' : ''}`;
        const id = `atr_${a.atributo_id}`;
        let campo;
        if (a.tipo_dato === 'lista') {
          const ops = typeof a.opciones === 'string' ? JSON.parse(a.opciones) : (a.opciones || []);
          campo = `<select id="${id}" class="form-control"><option value="">—</option>${ops.map((o) => `<option ${String(v) === o ? 'selected' : ''}>${esc(o)}</option>`).join('')}</select>`;
        } else if (a.tipo_dato === 'booleano') {
          campo = `<select id="${id}" class="form-control"><option value="">—</option><option value="1" ${v === true ? 'selected' : ''}>Sí</option><option value="0" ${v === false ? 'selected' : ''}>No</option></select>`;
        } else {
          const tipo = a.tipo_dato === 'numero' ? 'number" step="any' : a.tipo_dato === 'fecha' ? 'date' : 'text';
          campo = `<input type="${tipo}" id="${id}" class="form-control" value="${esc(v ?? '')}" />`;
        }
        return `<div class="form-group"><label>${lab}</label>${campo}</div>`;
      }).join('');
      sec.style.display = attrs.length ? 'block' : 'none';
    } catch (err) {
      toast.error(errMsg(err, 'No se pudo leer la línea'));
    }
  },

  leerAtributos() {
    const l = this.data.lineaActual;
    if (!l) return [];
    return (l.atributos || []).filter((a) => a.nivel === 'producto').map((a) => {
      const el = document.getElementById(`atr_${a.atributo_id}`);
      let v = el ? el.value.trim() : '';
      if (a.tipo_dato === 'booleano' && v !== '') v = v === '1';
      return { atributo_id: a.atributo_id, valor: v === '' ? null : v };
    });
  },

  limpiar() {
    this.data.editing = null;
    document.getElementById('prodForm')?.reset();
    document.getElementById('pr_clave').readOnly = false;
    document.getElementById('prodFormTitulo').textContent = 'Nuevo producto';
    document.getElementById('prodFormCard')?.classList.remove('editando');
    document.getElementById('btnProdGuardar').textContent = 'Guardar producto';
    const pza = this.data.unidades.find((u) => u.clave === 'PZA');
    if (pza) document.getElementById('pr_um').value = pza.id;
    this.alCambiarLinea('');
  },

  async editar(id) {
    try {
      const res = await catalogos.productos.obtener(id);
      const p = res?.data;
      this.data.editing = p;
      document.getElementById('prodFormTitulo').textContent = `Editar producto ${p.clave}`;
      document.getElementById('prodFormCard')?.classList.add('editando');
      document.getElementById('btnProdGuardar').textContent = 'Guardar cambios';
      const set = (i, v) => { const el = document.getElementById(i); if (el) el.value = v ?? ''; };
      set('pr_linea', p.linea_codigo);
      set('pr_clave', p.clave);
      set('pr_descripcion', p.descripcion);
      set('pr_marca', p.marca_id);
      set('pr_fabricante', p.fabricante_id);
      set('pr_modelo', p.modelo_id);
      set('pr_tipo', p.tipo);
      set('pr_uso', p.uso);
      set('pr_um', p.unidad_medida_id);
      set('pr_presentacion', p.presentacion);
      set('pr_contenido', p.contenido_neto != null ? Number(p.contenido_neto) : '');
      set('pr_sat', p.clave_prodserv_sat);
      set('pr_gar_otorga', p.garantia_otorga);
      set('pr_gar_meses', p.garantia_meses);
      set('pr_gar_horas', p.garantia_horas);
      set('pr_costo', p.costo_estimado != null ? Number(p.costo_estimado) : '');
      set('pr_costo_moneda', p.costo_estimado_moneda);
      ['req_gps', 'req_capacitacion', 'req_cliente_final', 'req_responsiva'].forEach((k) => { document.getElementById(`pr_${k}`).checked = !!p[k]; });
      await this.alCambiarLinea(p.linea_codigo, p.atributos || []);
      this.tabs.abrirFormulario({ editando: true, etiqueta: p.clave });
    } catch (err) {
      toast.error(errMsg(err, 'No se pudo abrir el producto'));
    }
  },

  async guardar() {
    const body = {
      linea_codigo: val('pr_linea'),
      descripcion: val('pr_descripcion'),
      marca_id: val('pr_marca') ? Number(val('pr_marca')) : null,
      fabricante_id: val('pr_fabricante') ? Number(val('pr_fabricante')) : null,
      modelo_id: val('pr_modelo') ? Number(val('pr_modelo')) : null,
      tipo: val('pr_tipo'),
      uso: val('pr_uso'),
      unidad_medida_id: Number(val('pr_um')),
      presentacion: val('pr_presentacion') || null,
      contenido_neto: numOrNull(val('pr_contenido')),
      clave_prodserv_sat: val('pr_sat') || null,
      garantia_otorga: val('pr_gar_otorga') || null,
      garantia_horas: numOrNull(val('pr_gar_horas')),
      costo_estimado: numOrNull(val('pr_costo')),
      costo_estimado_moneda: val('pr_costo_moneda') || null,
      req_gps: val('pr_req_gps'),
      req_capacitacion: val('pr_req_capacitacion'),
      req_cliente_final: val('pr_req_cliente_final'),
      req_responsiva: val('pr_req_responsiva'),
      atributos: this.leerAtributos()
    };
    const meses = numOrNull(val('pr_gar_meses'));
    if (meses !== null || this.data.editing) body.garantia_meses = meses;
    const clave = (val('pr_clave') || '').toUpperCase();
    if (!body.linea_codigo || !clave || !body.descripcion) { toast.warning('Línea, clave y descripción son obligatorias'); return; }
    try {
      if (this.data.editing) {
        if (clave !== this.data.editing.clave) body.clave = clave;
        await catalogos.productos.actualizar(this.data.editing.id, body);
        toast.success(`Producto ${clave} actualizado`);
      } else {
        await catalogos.productos.crear({ clave, ...body });
        toast.success(`Producto ${clave} creado`);
      }
      this.limpiar();
      this.tabs.volver();
      await this.cargar();
    } catch (err) {
      toast.error(errMsg(err));
    }
  },

  async cargar() {
    const body = document.getElementById('prodBody');
    try {
      const f = this.data.filters;
      const res = await catalogos.productos.listar({ search: f.search, linea: f.linea, marca_id: f.marca_id, incluir_eliminados: f.bajas || undefined, limit: 500 });
      this.data.productos = res?.data?.productos || [];
      const total = res?.data?.pagination?.total ?? this.data.productos.length;
      document.getElementById('prodTotal').textContent = `${total} producto(s)`;
      if (!this.data.productos.length) { body.innerHTML = '<tr><td colspan="8" class="text-center text-muted" style="padding:2rem;">Sin productos.</td></tr>'; return; }
      body.innerHTML = this.data.productos.map((p) => `
        <tr ${!p.activo || p.deleted_at ? 'style="opacity:.6;"' : ''}>
          <td><code>${esc(p.clave)}</code></td>
          <td>${esc(p.descripcion)}${p.presentacion ? ` <span class="text-muted">· ${esc(p.presentacion)}</span>` : ''}
            ${p.uso === 'interno' ? ' <span class="erp-chip">uso interno</span>' : ''}${p.tipo === 'servicio' ? ' <span class="erp-chip">servicio</span>' : ''}</td>
          <td class="tbl-hide-mobile">${esc(p.linea_codigo)}</td>
          <td class="tbl-hide-mobile">${p.marca_nombre ? esc(p.marca_nombre) : '<span class="text-muted">—</span>'}</td>
          <td class="tbl-hide-mobile">${chipsControles(p.controles)}</td>
          <td class="tbl-hide-mobile">${esc(p.unidad_clave)}</td>
          <td>${estadoBadge(p)}</td>
          <td style="text-align:right;white-space:nowrap;">
            ${p.deleted_at ? (permisos.canDelete('productos') ? `<button class="btn-icon btn-success" title="Restaurar" onclick="window.currentView.restaurar(${p.id})">↩️</button>` : '') : `
              ${permisos.canEdit('productos') ? `<button class="btn-icon btn-edit" title="Editar" onclick="window.currentView.editar(${p.id})">✏️</button>
                <button class="btn-icon ${p.activo ? 'btn-warning' : 'btn-success'}" title="${p.activo ? 'Desactivar' : 'Activar'}" onclick="window.currentView.toggle(${p.id})">${p.activo ? '⏸️' : '▶️'}</button>` : ''}
              ${permisos.canDelete('productos') ? `<button class="btn-icon btn-danger" title="Dar de baja" onclick="window.currentView.baja(${p.id})">🗑️</button>` : ''}`}
          </td>
        </tr>`).join('');
    } catch (err) {
      body.innerHTML = `<tr><td colspan="8" class="text-center" style="color:var(--danger);padding:2rem;">${esc(errMsg(err, 'Error al cargar'))}</td></tr>`;
    }
  },

  async toggle(id) {
    const p = this.data.productos.find((x) => x.id === id);
    try { await catalogos.productos.actualizar(id, { activo: !p.activo }); toast.success(p.activo ? 'Producto desactivado' : 'Producto activado'); await this.cargar(); } catch (err) { toast.error(errMsg(err)); }
  },

  baja(id) {
    const p = this.data.productos.find((x) => x.id === id);
    modal.confirm('Dar de baja el producto', `<p>¿Dar de baja <strong>${esc(p.clave)} — ${esc(p.descripcion)}</strong>?</p><p class="text-muted">«Baja» es para lo capturado por error; si sólo ya no se vende, desactívalo.</p>`, async () => {
      try { await catalogos.productos.eliminar(id); toast.success('Producto dado de baja'); await this.cargar(); } catch (err) { toast.error(errMsg(err)); }
    });
  },

  async restaurar(id) {
    try { await catalogos.productos.restaurar(id); toast.success('Producto restaurado'); await this.cargar(); } catch (err) { toast.error(errMsg(err)); }
  }
};
